import React from "react";
import { useNavigate } from "react-router-dom";

type TeamNameInputProps = {
  teamId: string;
};

export const DeleteTeam = ({ teamId }: TeamNameInputProps) => {
  const navigate = useNavigate();

  const handleDeleteTeam = async () => {
    try {
      console.log("delete team now " + teamId);
      //await TeamService.deleteTeam(teamId);
      navigate("/app/home");
    } catch (error) {
      console.error("Failed to delete team", error);
      const message =
        error instanceof Error ? error.message : "Failed to delete team.";
      alert(message);
    }
  };

  return (
    <div className="select-component__duration-section">
      <div style={{ display: "inline-flex", paddingLeft: "12px" }}>
        <p style={{ color: "#FF3B30" }} onClick={handleDeleteTeam}>
          Delete team
        </p>
      </div>
    </div>
  );
};
